import { HubCookieInit } from './Cookie';
import LoginWebPart from './Login';
import HubConfigInit from './Config';
import { ValidateUser } from './Validate';
import HeaderInit from './Header/index';
import MeetingEmbed from './MeetingEmbed';
import SecureLinkout from './SecureLinkout';
import { MemberHomeRedirector } from './MemberHomeRedirector';
import  AbstractsWebPart  from './Abstracts';
import  TokenLogin  from './TokenLogin';

const bootstrap = element => {
    //TODO: For some reach the bootstrapper is being executed twice. Added a temp fix
    if (window.bootstrapped) {
        return;
    } else {
        window.bootstrapped = true;
    }

    HubConfigInit(element);
    HubCookieInit(element);
    TokenLogin(element);
    ValidateUser(element);
    MemberHomeRedirector(element);
    LoginWebPart(element);

    //Add new initializers here
    HeaderInit(element);
    MeetingEmbed(element);
    SecureLinkout(element);
    AbstractsWebPart(element);
    
};

export default bootstrap;


// WEBPACK FOOTER //
// ./src/nams2020/webparts/index.js